"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _Dashboard = _interopRequireDefault(require("./components/Dashboard.vue"));
var _SeeMore = _interopRequireDefault(require("./components/SeeMore.vue"));
var _DetailsDashboardProcessing = _interopRequireDefault(require("./components/DetailsDashboardProcessing.vue"));
var _DetailsDasboardError = _interopRequireDefault(require("./components/DetailsDasboardError.vue"));
var chartConfig = _interopRequireWildcard(require("@/components/Charts/chart.config.js"));
var _constants = require("@/config/constants");
var _auth = require("@/utils/auth");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var now = new Date();
var _default = exports.default = {
  name: 'PainelComponent',
  bodyClass: 'painel-watch',
  components: {
    Dashboard: _Dashboard.default,
    SeeMore: _SeeMore.default,
    DetailsDashboardProcessing: _DetailsDashboardProcessing.default,
    DetailsDasboardError: _DetailsDasboardError.default
  },
  data: function data() {
    return {
      TYPE_ITEM_DASHBOARD: _constants.TYPE_ITEM_DASHBOARD,
      typeSelected: _constants.TYPE_ITEM_DASHBOARD.RECEPTIONIST,
      listServicesOnErrorTransactions: [],
      isLoadingReceptionist: false,
      activeTab: 0,
      intervalId: null,
      listLastResultsSocket: null,
      timeDash: '0',
      businessUnitSelect: null,
      dates: [now, now],
      chartData: {},
      loadChart: false,
      createdHiveConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        lastUpdate: null
      },
      createdProviderConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        lastUpdate: null
      },
      receivedHiveConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        lastUpdate: null
      },
      sendClientConsolidated: {
        isLoading: true,
        qtyTotal: 0,
        qtyErrors: 0,
        qtySuccess: 0,
        qtyProcessing: 0,
        qtyReceivedFailed: 0,
        lastUpdate: null
      },
      createHive: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      hiveProvider: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      providerHive: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      hiveClient: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      createHiveError: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      hiveProviderError: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      providerHiveError: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      },
      hiveClientError: {
        partOfTheWhole: 0,
        data: [],
        total: 0
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listLastResults'])), {}, {
    computedListLastResults: function computedListLastResults() {
      var _this = this;
      var sourceData = this.listLastResultsSocket || this.listLastResults;
      if (sourceData.rows) {
        return sourceData.rows.map(function (row) {
          if (row.date_start) {
            row.date_start = _this.$options.filters.dateComplete(row.date_start);
          }
          if (row.http_status) {
            row.http_status = _this.$options.filters.typeTransaction(row.http_status);
          }
          return row;
        });
      }
      return [];
    },
    filterItems: function filterItems() {
      return {
        StartDate: (0, _moment.default)(this.dates[0]).format('YYYY-MM-DD'),
        EndDate: (0, _moment.default)(this.dates[1]).add(1, 'days').format('YYYY-MM-DD'),
        businessUnit: this.businessUnitSelect
      };
    }
  }),
  created: function created() {
    this.getDataConsolidated('created_hive');
    this.getDataConsolidated('hive_provider');
    this.getDataConsolidated('provider_hive');
    this.getDataConsolidated('hive_client');
    this.getCreateHive();
    this.getHiveProvider();
    this.getProviderHive();
    this.getHiveClient();
    this.getErros();
  },
  mounted: function mounted() {
    var _this2 = this;
    var token = (0, _auth.getToken)();
    this.ws = new WebSocket(process.env.VUE_APP_BASE_API_PATH);
    this.ws.onmessage = function (event) {
      var msg = JSON.parse(event.data);
      if (msg.event === 'consolidated_create_hive' && _this2.activeTab === 0) {
        _this2.createdHiveConsolidated = {
          isLoading: false,
          qtyTotal: msg.data.qtyTotal,
          qtyErrors: msg.data.qtyErrors,
          qtySuccess: msg.data.qtySuccess,
          qtyProcessing: msg.data.qtyProcessing,
          lastUpdate: msg.data.lastUpdate
        };
      }
      if (msg.event === 'consolidated_create_provider' && _this2.activeTab === 0) {
        _this2.createdProviderConsolidated = {
          isLoading: false,
          qtyTotal: msg.data.qtyTotal,
          qtyErrors: msg.data.qtyErrors,
          qtySuccess: msg.data.qtySuccess,
          qtyProcessing: msg.data.qtyProcessing,
          lastUpdate: msg.data.lastUpdate
        };
      }
      if (msg.event === 'consolidated_receveid_hive' && _this2.activeTab === 0) {
        _this2.receivedHiveConsolidated = {
          isLoading: false,
          qtyTotal: msg.data.qtyTotal,
          qtyErrors: msg.data.qtyErrors,
          qtySuccess: msg.data.qtySuccess,
          qtyProcessing: msg.data.qtyProcessing,
          lastUpdate: msg.data.lastUpdate
        };
      }
      if (msg.event === 'consolidated_send_client' && _this2.activeTab === 0) {
        _this2.sendClientConsolidated = {
          isLoading: false,
          qtyTotal: msg.data.qtyTotal,
          qtyErrors: msg.data.qtyErrors,
          qtySuccess: msg.data.qtySuccess,
          qtyProcessing: msg.data.qtyProcessing,
          lastUpdate: msg.data.lastUpdate
        };
      }
      if (msg.event === 'list_last_results' && _this2.activeTab === 0) {
        _this2.listLastResultsSocket = msg.data;
      }
      if (msg.event === 'list_errors' && _this2.activeTab === 0) {
        _this2.listServicesOnErrorTransactions = msg.data;
      }
      if (msg.event === 'client_hive' && (_this2.activeTab === 1 || _this2.activeTab === 2)) {
        _this2.createHive = {
          partOfTheWhole: parseFloat(msg.data.totalProcessPercent),
          data: msg.data.processList,
          total: msg.data.totalProcess
        };
        _this2.createHiveError = {
          partOfTheWhole: parseFloat(msg.data.totalErrorsPercent),
          data: msg.data.errorList,
          total: msg.data.totalErrors
        };
      }
      if (msg.event === 'hive_provider' && (_this2.activeTab === 1 || _this2.activeTab === 2)) {
        _this2.hiveProvider = {
          partOfTheWhole: parseFloat(msg.data.totalProcessPercent),
          data: msg.data.processList,
          total: msg.data.totalProcess
        };
        _this2.hiveProviderError = {
          partOfTheWhole: parseFloat(msg.data.totalErrorsPercent),
          data: msg.data.errorList,
          total: msg.data.totalErrors
        };
      }
      if (msg.event === 'provider_hive' && (_this2.activeTab === 1 || _this2.activeTab === 2)) {
        _this2.providerHive = {
          partOfTheWhole: parseFloat(msg.data.totalProcessPercent),
          data: msg.data.processList,
          total: msg.data.totalProcess
        };
        _this2.providerHiveError = {
          partOfTheWhole: parseFloat(msg.data.totalErrorsPercent),
          data: msg.data.errorList,
          total: msg.data.totalErrors
        };
      }
      if (msg.event === 'hive_client' && (_this2.activeTab === 1 || _this2.activeTab === 2)) {
        _this2.hiveClient = {
          partOfTheWhole: parseFloat(msg.data.totalProcessPercent),
          data: msg.data.processList,
          total: msg.data.totalProcess
        };
        _this2.hiveClientError = {
          partOfTheWhole: parseFloat(msg.data.totalErrorsPercent),
          data: msg.data.errorList,
          total: msg.data.totalErrors
        };
      }
      if (msg.event === 'all_services_actives' && _this2.activeTab === 3) {
        _this2.configChartData(msg.data);
      }
    };
    this.intervalId = setInterval(function () {
      _this2.ws.send(token);
    }, 5000);
    this.fillChartData();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
    if (this.ws) {
      this.ws.close();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchDashboardDataConsolidatedCreatedHive', 'fetchDashboardDataConsolidatedCreatedProvider', 'fetchDashboardDataConsolidatedReceivedHive', 'fetchDashboardDataConsolidatedSendClient', 'fetchProtocolsDetailsByPhaseGroupByTypeInLastDays', 'fetchLatestServiceCallChartDashboard', 'fetchListErrorsReceptionist'])), {}, {
    goBack: function goBack() {
      this.$router.back();
    },
    getDataConsolidated: function () {
      var _getDataConsolidated = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
        var params, functionBind, dataBind, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              params = {
                days: this.timeDash
              };
              functionBind = this.fetchDashboardDataConsolidatedCreatedHive;
              dataBind = 'createdHiveConsolidated';
              _t = type;
              _context.n = _t === 'hive_provider' ? 1 : _t === 'provider_hive' ? 2 : _t === 'hive_client' ? 3 : 4;
              break;
            case 1:
              functionBind = this.fetchDashboardDataConsolidatedCreatedProvider;
              dataBind = 'createdProviderConsolidated';
              return _context.a(3, 4);
            case 2:
              functionBind = this.fetchDashboardDataConsolidatedReceivedHive;
              dataBind = 'receivedHiveConsolidated';
              return _context.a(3, 4);
            case 3:
              functionBind = this.fetchDashboardDataConsolidatedSendClient;
              dataBind = 'sendClientConsolidated';
              return _context.a(3, 4);
            case 4:
              _context.n = 5;
              return functionBind(params);
            case 5:
              data = _context.v;
              if (data) this[dataBind] = data;
              this[dataBind].isLoading = false;
            case 6:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDataConsolidated(_x) {
        return _getDataConsolidated.apply(this, arguments);
      }
      return getDataConsolidated;
    }(),
    getErros: function () {
      var _getErros = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var date, startDate, endDate, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              date = (0, _moment.default)().subtract(this.timeDash, 'days');
              startDate = date.format('YYYY-MM-DD');
              endDate = (0, _moment.default)().add(1, 'days').format('YYYY-MM-DD');
              this.isLoadingReceptionist = true;
              _context2.n = 1;
              return this.fetchListErrorsReceptionist({
                days: this.timeDash,
                params: {
                  startDate: startDate,
                  endDate: endDate,
                  type: this.typeSelected
                }
              });
            case 1:
              data = _context2.v;
              if (data) this.listServicesOnErrorTransactions = data;
              this.isLoadingReceptionist = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function getErros() {
        return _getErros.apply(this, arguments);
      }
      return getErros;
    }(),
    getCreateHive: function () {
      var _getCreateHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var perService;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.fetchProtocolsDetailsByPhaseGroupByTypeInLastDays({
                phase: 'client-hive',
                group: 'service',
                days: 0
              });
            case 1:
              perService = _context3.v;
              this.createHive.data = perService.processList;
              this.createHive.partOfTheWhole = parseInt(perService.totalProcessPercent);
              this.createHive.total = perService.totalProcess;
              this.createHiveError.data = perService.errorList;
              this.createHiveError.partOfTheWhole = parseInt(perService.totalErrorsPercent);
              this.createHiveError.total = perService.totalErrors;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function getCreateHive() {
        return _getCreateHive.apply(this, arguments);
      }
      return getCreateHive;
    }(),
    getHiveProvider: function () {
      var _getHiveProvider = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var perService;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.fetchProtocolsDetailsByPhaseGroupByTypeInLastDays({
                phase: 'hive-provider',
                group: 'service',
                days: 0
              });
            case 1:
              perService = _context4.v;
              this.hiveProvider.data = perService.processList;
              this.hiveProvider.partOfTheWhole = parseInt(perService.totalProcessPercent);
              this.hiveProvider.total = perService.totalProcess;
              this.hiveProviderError.data = perService.errorList;
              this.hiveProviderError.partOfTheWhole = parseInt(perService.totalErrorsPercent);
              this.hiveProviderError.total = perService.totalErrors;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function getHiveProvider() {
        return _getHiveProvider.apply(this, arguments);
      }
      return getHiveProvider;
    }(),
    getProviderHive: function () {
      var _getProviderHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var perService;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.fetchProtocolsDetailsByPhaseGroupByTypeInLastDays({
                phase: 'provider-hive',
                group: 'service',
                days: 0
              });
            case 1:
              perService = _context5.v;
              this.providerHive.data = perService.processList;
              this.providerHive.partOfTheWhole = parseInt(perService.totalProcessPercent);
              this.providerHive.total = perService.totalProcess;
              this.providerHiveError.data = perService.errorList;
              this.providerHiveError.partOfTheWhole = parseInt(perService.totalErrorsPercent);
              this.providerHiveError.total = perService.totalErrors;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function getProviderHive() {
        return _getProviderHive.apply(this, arguments);
      }
      return getProviderHive;
    }(),
    getHiveClient: function () {
      var _getHiveClient = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var perService;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.fetchProtocolsDetailsByPhaseGroupByTypeInLastDays({
                phase: 'hive-client',
                group: 'service',
                days: 0
              });
            case 1:
              perService = _context6.v;
              this.hiveClient.data = perService.processList;
              this.hiveClient.partOfTheWhole = parseInt(perService.totalProcessPercent);
              this.hiveClient.total = perService.totalProcess;
              this.hiveClientError.data = perService.errorList;
              this.hiveClientError.partOfTheWhole = parseInt(perService.totalErrorsPercent);
              this.hiveClientError.total = perService.totalErrors;
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function getHiveClient() {
        return _getHiveClient.apply(this, arguments);
      }
      return getHiveClient;
    }(),
    fillChartData: function () {
      var _fillChartData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.loadChart = true;
              _context7.n = 1;
              return this.fetchLatestServiceCallChartDashboard(this.filterItems);
            case 1:
              data = _context7.v;
              this.configChartData(data);
              this.loadChart = false;
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function fillChartData() {
        return _fillChartData.apply(this, arguments);
      }
      return fillChartData;
    }(),
    configChartData: function () {
      var _configChartData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(data) {
        var labels, services, datasets, _loop, i;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              labels = [];
              services = [];
              datasets = [];
              if (!(data && data.length)) {
                _context0.n = 3;
                break;
              }
              data.map(function (i) {
                if (!labels.includes(i.hour)) {
                  labels.push(i.hour);
                }
                var service = i.service || 'url-invalida';
                if (!services.includes(service)) {
                  services.push(service);
                }
              });
              chartConfig.resetColorIndex();
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var service, values, _loop2, j, item;
                return _regenerator().w(function (_context9) {
                  while (1) switch (_context9.n) {
                    case 0:
                      service = services[i];
                      values = [];
                      _loop2 = /*#__PURE__*/_regenerator().m(function _loop2() {
                        var dt, item;
                        return _regenerator().w(function (_context8) {
                          while (1) switch (_context8.n) {
                            case 0:
                              dt = labels[j];
                              item = data.find(function (j) {
                                var serviceCompare = j.service || 'url-invalida';
                                return serviceCompare === service && j.hour === dt;
                              });
                              if (item) {
                                values.push(item.totalRequests);
                              } else {
                                values.push(0);
                              }
                            case 1:
                              return _context8.a(2);
                          }
                        }, _loop2);
                      });
                      j = 0;
                    case 1:
                      if (!(j < labels.length)) {
                        _context9.n = 3;
                        break;
                      }
                      return _context9.d(_regeneratorValues(_loop2()), 2);
                    case 2:
                      j++;
                      _context9.n = 1;
                      break;
                    case 3:
                      item = chartConfig.datasetObjectItemPainel(values, service);
                      datasets.push(item);
                    case 4:
                      return _context9.a(2);
                  }
                }, _loop);
              });
              i = 0;
            case 1:
              if (!(i < services.length)) {
                _context0.n = 3;
                break;
              }
              return _context0.d(_regeneratorValues(_loop()), 2);
            case 2:
              i++;
              _context0.n = 1;
              break;
            case 3:
              this.chartData = {
                labels: labels,
                datasets: datasets
              };
            case 4:
              return _context0.a(2);
          }
        }, _callee8, this);
      }));
      function configChartData(_x2) {
        return _configChartData.apply(this, arguments);
      }
      return configChartData;
    }()
  })
};